import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { authActions } from "@/entities/Auth";
import { UserData } from "@/entities/User";
import { LC_AUTH_TOKEN } from "@/shared/const/storageKeys";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

import { validateLogin } from "./validateLogin";

interface LoginPayload {
  token: string;
  user: UserData;
}

interface LoginProps {
  email: string;
  password: string;
}

export const login = createAsyncThunk<void, LoginProps, ThunkConfig<ApiError>>(
  "auth/login",
  async (params, thunkApi) => {
    const { extra, dispatch, rejectWithValue } = thunkApi;

    const errors = validateLogin(params);
    if (errors) {
      return rejectWithValue(errors);
    }

    try {
      const response = await extra.api.post<LoginPayload>("/api/auth/token", params, {
        headers: {
          Authorization: null,
        },
      });

      localStorage.setItem(LC_AUTH_TOKEN, response.data.token);

      dispatch(authActions.setUserData(response.data.user));
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
